(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["search"]) return;
  try {
    
if (!customElements.get('ut-search-sort')) {
  customElements.define('ut-search-sort', class extends HTMLElement {
    connectedCallback() {
      this.querySelector('select').addEventListener('change', event => {
        const url = new URL(location.href);
        url.searchParams.set('sort_by', event.target.value);
        url.searchParams.delete('page');
        const filters=this.closest('.ut-search-page').querySelector('ut-collection-filters');
        if(filters?.update)filters.update(url,true);else location.assign(url.href);
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
